import classNames from 'classnames';
import { createElement } from 'react';
import './index.scss';
const ColorfulTag = function ColorfulTag({ type, text, color, closeable, onClose, ...props }) {
    const prefixCls = 'au-tag';
    const tagClassName = classNames(prefixCls, {
        [`${prefixCls}-${color}`]: !!color,
        [`${prefixCls}-${type}`]: !!type,
    });
    const handleClose = () => {
        onClose();
    };
    const tagNode = (createElement("label", { ...props, className: tagClassName },
        createElement("span", null, text || '标签'),
        closeable && createElement("i", { className: 'icon-times-circle', onClick: handleClose })));
    return tagNode;
};
ColorfulTag.displayName = 'ColorfulTag';
export default ColorfulTag;
